var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { CurrencyEnum, LotteryJackpotDrawStatusEnum } from "../../../../../models/modules/lotteryplatofrm.models";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { SourceType } from "../../../../../models/queries/queries.models";
import * as Enumerable from "linq";
import { BillingClientService } from "../../../../../services/modules/billing-client.service";
import { LotteryClientService } from "../../../../../services/modules/lottery-client.service";
import { LotteryDateHelper } from "./lottery-date-helper";
import { QueriesEditor } from "../../../../components/queries/queries-editor";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { LotteryPlatformClaims } from "../../../../../constants/modules/lotteryplatform.claims";
import { CurrencyClientService } from "../../../../../services/modules/currency-client.service";
var LotteryBasicMeta = /** @class */ (function (_super) {
    __extends(LotteryBasicMeta, _super);
    function LotteryBasicMeta(notificationService, i18N, tokenClient, currencyClientService, dialogClientService, billingService, lotteryService, userClaimsService, queriesService) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.tokenClient = tokenClient;
        _this.currencyClientService = currencyClientService;
        _this.dialogClientService = dialogClientService;
        _this.billingService = billingService;
        _this.lotteryService = lotteryService;
        _this.userClaimsService = userClaimsService;
        _this.queriesService = queriesService;
        return _this;
    }
    LotteryBasicMeta.prototype.onActivated = function (item) {
        var _this = this;
        _super.prototype.onActivated.call(this, item);
        this.lotteryDate = new LotteryDateHelper(item);
        this.getLotteryDrawsOdata(item.lotteryId);
        if (item.lotteryId > 0) {
            this.lotteryService.getLotteryDrawsForPeriod(item.lotteryId, item.navigationInfo ? item.navigationInfo.brandId : null, item.navigationInfo ? item.navigationInfo.operatorId : null)
                .then(function (x) {
                _this.totalTicketsSold = x;
            }).catch(function (error) {
                _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
            });
            this.billingService.getCurrentPeriodBilling(item.navigationInfo ? item.navigationInfo.brandId : null, item.navigationInfo ? item.navigationInfo.operatorId : null, item.lotteryId)
                .then(function (response) {
                _this.totalInsuranceClaims = response.claims.totalInsurancePayout;
                _this.totalClaimBrandPayout = response.claims.totalBrandPayout;
                _this.totalInsuranceWithholding = response.claims.totalInsurancePayoutPolicyDeduction;
                _this.totalRevenue = response.postingTotal && response.postingTotal.totalTicketPriceInEuro ? response.postingTotal.totalTicketPriceInEuro : 0;
                _this.totalCost = response.postingTotal && response.postingTotal.totalTicketCost ? response.postingTotal.totalTicketCost : 0;
                var totalCostAdjustment = response.adjustmentTotal.totalDifferenceInCosts;
                _this.totalBrandProfit = _this.totalRevenue - (_this.totalCost + totalCostAdjustment) - (_this.totalClaimBrandPayout ? _this.totalClaimBrandPayout : 0);
                var totalPlatformMargin = response.postingTotal.totalPlatformMargin + response.adjustmentTotal.totalDifferenceInPlatformMargin;
                var totalInsuranceMargin = response.postingTotal.totalInsuranceProfit + response.adjustmentTotal.totalInsuranceProfit;
                _this.totalProfit = totalPlatformMargin + totalInsuranceMargin;
            }).catch(function (error) {
                _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
            });
        }
        this.currencyClientService.getRates().then(function (rates) {
            _this.currencyRates = Enumerable.from(rates);
        });
    };
    LotteryBasicMeta.prototype.onSelectCurrency = function (event) {
        var currencyId = event.detail.item == undefined ? null : event.detail.item.id;
        var selectedCurrencyId = this.currencyRates.firstOrDefault(function (x) { return x.currencyId == currencyId; });
        var rate = selectedCurrencyId ? selectedCurrencyId.euroRate : 1;
        this.jackpotValueDisplayInEuro = this.jackpotValueConvertToEuro(rate);
    };
    LotteryBasicMeta.prototype.jackpotValueConvertToEuro = function (rate) {
        if (this.item.currencyId != CurrencyEnum.Euro) {
            var lotteryjackpotInEur = Math.round(this.item.currentJackpotDraw.totalJackpot / rate);
            var euroSign = '\u20AC'; // setting euro sign here because in frontend, the euro sign was not rendering 
            return "(".concat(euroSign, ": ").concat(lotteryjackpotInEur.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), ")"); // lotteryjackpotInEur value formating like 1,000,000
        }
        return "";
    };
    Object.defineProperty(LotteryBasicMeta.prototype, "showManageTemplate", {
        get: function () {
            return (this.item.navigationInfo && this.item.navigationInfo.brandId) // is brand
                || (this.item.navigationInfo && !this.item.navigationInfo.operatorId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotteryBasicMeta.prototype, "canManageBrandLottery", {
        // Grant-to-reveal: editing lottery assets in brand context requires ManageBrandLottery; default/global editing is unaffected.
        get: function () {
            return !(this.item && this.item.navigationInfo && this.item.navigationInfo.brandId)
                || this.userClaimsService.hasPermission(LotteryPlatformClaims.ManageBrandLottery);
        },
        enumerable: false,
        configurable: true
    });
    LotteryBasicMeta.prototype.isReadonly = function () {
        if (this.item && !this.item.navigationInfo)
            return false;
        else
            return this.item.navigationInfo.operatorId || this.item.navigationInfo.brandId;
    };
    Object.defineProperty(LotteryBasicMeta.prototype, "isBrandAdmin", {
        get: function () {
            return this.tokenClient.isBrandAdmin();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotteryBasicMeta.prototype, "isAdmin", {
        get: function () {
            return this.tokenClient.isSuperAdmin();
        },
        enumerable: false,
        configurable: true
    });
    LotteryBasicMeta.prototype.editBranding = function () {
        require("../dialogs/lottery-render-dialog");
        this.dialogClientService.show(DialogServiceConstants.URLs.LotteryRender, this.item, false, false, true);
    };
    LotteryBasicMeta.prototype.getLotteryDrawsOdata = function (lotteryId) {
        var _this = this;
        if (lotteryId) {
            var ticketLinesPath_1 = "LotteryJackpotDraws";
            this.queriesService.getEntityModels().then(function (models) {
                var e_1, _a;
                var columns = [];
                var selectedModel = Enumerable.from(models).firstOrDefault(function (y) { return y.uri == ticketLinesPath_1; });
                try {
                    for (var _b = __values(selectedModel.projectionProperties), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        var column = QueriesEditor.generateDefaultColumn(item, selectedModel);
                        ;
                        columns.push(column);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                var oDataUrl = "/odata/".concat(ticketLinesPath_1, "?$filter=lotteryId eq ").concat(lotteryId);
                _this.itemSource = {
                    source: oDataUrl,
                    sourceType: SourceType.ODataUrl,
                    columns: columns,
                    groupInitialFilters: true
                };
            }).catch(function (error) {
                _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
            });
        }
    };
    LotteryBasicMeta.prototype.showEditManualLotteryDraw = function (lotteryjackpotItem, lottery) {
        lotteryjackpotItem.lottery = lottery;
        if (this.canUpdateDrawResults(lotteryjackpotItem) || this.canReviewDrawResults(lotteryjackpotItem)) {
            this.callDialog(lotteryjackpotItem);
        }
        else if ((lotteryjackpotItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.ActionRequired) ||
            (lotteryjackpotItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.ActionRequiredEmailSent) ||
            (lotteryjackpotItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.EmailSentToReview) ||
            (lotteryjackpotItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.ResultsToReview)) {
            this.notificationService.show("Validation Error!", "You don't have an access to review/update these details.", NotificationType.Error);
        }
    };
    LotteryBasicMeta.prototype.callDialog = function (lotteryjackpotItem) {
        require("../dialogs/lottery-jackpot-draw-history-dialog");
        this.dialogClientService.show(DialogServiceConstants.URLs.LotteryJackpotDrawHistoryDialog, lotteryjackpotItem, true, true);
    };
    LotteryBasicMeta.prototype.canUpdateDrawResults = function (lotteryjackpotItem) {
        return (this.userClaimsService.hasPermission(LotteryPlatformClaims.UpdateDrawResult) &&
            (lotteryjackpotItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.ActionRequired ||
                lotteryjackpotItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.ActionRequiredEmailSent));
    };
    LotteryBasicMeta.prototype.canReviewDrawResults = function (lotteryjackpotItem) {
        return (this.userClaimsService.hasPermission(LotteryPlatformClaims.ReviewDrawResult) &&
            ((lotteryjackpotItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.EmailSentToReview) ||
                (lotteryjackpotItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.ResultsToReview)));
    };
    LotteryBasicMeta.prototype.formatDate = function (dateString) {
        var date = new Date(dateString);
        return date.toLocaleDateString('en-GB');
    };
    LotteryBasicMeta = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N, TokenClient, CurrencyClientService,
            DialogClientService, BillingClientService, LotteryClientService,
            UserClaimsService, QueriesClientService])
    ], LotteryBasicMeta);
    return LotteryBasicMeta;
}(ChildComponent));
export { LotteryBasicMeta };
